'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _messages = require('redux/modules/messages');

var _components = require('components');

var _Close = require('@material-ui/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Snackbar = require('@material-ui/core/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _channel = require('redux/modules/channel');

var _auth = require('redux/modules/auth');

var _reachHistory = require('../../../helpers/reachHistory');

var _email = require('redux/modules/email');

var _Resumen = require('./Resumen.scss');

var _Resumen2 = _interopRequireDefault(_Resumen);

var _useBasename = require('../../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resumen = (_dec = (0, _reduxConnect.asyncConnect)([{
    key: "auth",
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        if (!isAuthLoaded(getState())) {
            return dispatch((0, _auth.load)());
        }
        return null;
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return { auth: state.auth, account: state.account.data };
}, { sendEmail: _email.sendEmail, messageConfirmSendFile: _messages.messageConfirmSendFile, push: _reachHistory.push, getAccount: _account.getAccount, getEmailChannel: _channel.getEmailChannel }), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(Resumen, _React$Component);

    function Resumen(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, Resumen);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Resumen.__proto__ || (0, _getPrototypeOf2.default)(Resumen)).call(this, props));

        _this.queue = [];

        _this.handleClick = function (message) {
            return function () {
                _this.queue.push({
                    message: message,
                    key: new Date().getTime()
                });

                if (_this.state.open) {
                    // immediately begin dismissing current message
                    // to start showing new one
                    _this.setState({ open: false });
                } else {
                    _this.processQueue();
                }
            };
        };

        _this.processQueue = function () {
            if (_this.queue.length > 0) {
                _this.setState({
                    messageInfo: _this.queue.shift(),
                    open: true
                });
            }
        };

        _this.getTestEmail = function (change) {
            _this.setState({ individual: change.target.value });
        };

        _this.sendEmail = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var recipients, params, _this$state, channel_identifier, template_config_uid, account_uid, file_data, status, send, _send;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                recipients = [], params = void 0;
                                _this$state = _this.state, channel_identifier = _this$state.channel_identifier, template_config_uid = _this$state.template_config_uid, account_uid = _this$state.account_uid;

                                if (!(_this.props.file && when == 'send')) {
                                    _context.next = 20;
                                    break;
                                }

                                file_data = _this.props.draggedFileData.file_data;

                                file_data['template_uid'] = template_config_uid;
                                file_data['channel_identifier'] = channel_identifier;
                                file_data['subject'] = _this.props.data.dataToSend.properties ? _this.props.data.dataToSend.properties.subject : _this.props.data.dataToSend.subject;
                                file_data['channel_type'] = 'EMAIL';
                                _context.prev = 8;
                                _context.next = 11;
                                return _this.state.messageConfirmSendFile(file_data, _messages.channelTypes.EMAIL);

                            case 11:
                                status = _context.sent;

                                if (status) {
                                    _this.props.push({
                                        pathname: '/success',
                                        state: {
                                            goTo: '/email/file',
                                            goToModal: false,
                                            message: 'Los correos han sido enviados',
                                            modal: true,
                                            returnTo: '/email/file'
                                        }
                                    });
                                }
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](8);

                                _this.props.push({
                                    pathname: '/fail',
                                    state: {
                                        goTo: '/email/file',
                                        goToModal: false,
                                        message: 'Error al momento de enviar',
                                        modal: true,
                                        returnTo: '/email/file'
                                    }
                                });

                            case 18:
                                _context.next = 54;
                                break;

                            case 20:
                                if (!(when == 'test')) {
                                    _context.next = 49;
                                    break;
                                }

                                recipients.push(_this.state.individual);
                                params = {
                                    channel_identifier: channel_identifier,
                                    template_config_uid: template_config_uid,
                                    account_uid: account_uid,
                                    created_by: _this.props.auth.data.user.email,
                                    subject: _this.props.data.dataToSend.properties ? _this.props.data.dataToSend.properties.subject : _this.props.data.dataToSend.subject,
                                    recipients: recipients,
                                    channel_type: 'EMAIL'
                                };

                                if (!(_this.state.individual != '')) {
                                    _context.next = 44;
                                    break;
                                }

                                if (!/^[a-zA-Z0-9.-_]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(_this.state.individual)) {
                                    _context.next = 39;
                                    break;
                                }

                                _context.prev = 25;
                                _context.next = 28;
                                return _this.state.sendEmail(params);

                            case 28:
                                send = _context.sent;

                                if (send) {
                                    console.log('NO ESTÁ VACÍO');
                                    console.log('email enviado');
                                    _this.setState({ messageInfo: { message: "Email enviado", key: '_success' } });
                                    _this.setState({ open: true });
                                }
                                _context.next = 37;
                                break;

                            case 32:
                                _context.prev = 32;
                                _context.t1 = _context['catch'](25);

                                console.log('email no enviado');
                                _this.setState({ messageInfo: { message: "Email no enviado", key: '_internalError' } });
                                _this.setState({ open: true });

                            case 37:
                                _context.next = 42;
                                break;

                            case 39:
                                console.log('EMAIL INVALIDO');
                                _this.setState({ messageInfo: { message: "Ingrese un email váildo", key: '_wrongEmail' } });
                                _this.setState({ open: true });

                            case 42:
                                _context.next = 47;
                                break;

                            case 44:
                                console.log('CAMPO VACÍO');
                                _this.setState({ messageInfo: { message: "Ingrese un email de prueba", key: '_nullEmail' } });
                                _this.setState({ open: true });

                            case 47:
                                _context.next = 54;
                                break;

                            case 49:
                                params = {
                                    channel_identifier: channel_identifier,
                                    template_config_uid: template_config_uid,
                                    account_uid: account_uid,
                                    created_by: _this.props.auth.data.user.email,
                                    subject: _this.props.data.dataToSend.properties ? _this.props.data.dataToSend.properties.subject : _this.props.data.dataToSend.subject,
                                    recipients: _this.state.recipients,
                                    channel_type: 'EMAIL'
                                };
                                _context.next = 52;
                                return _this.state.sendEmail(params);

                            case 52:
                                _send = _context.sent;

                                if (_send) {
                                    _this.props.push({
                                        pathname: '/success',
                                        state: {
                                            goTo: '/email',
                                            goToModal: false,
                                            message: 'Los correos han sido enviados',
                                            modal: true,
                                            returnTo: '/email'
                                        }
                                    });
                                } else {
                                    _this.props.push({
                                        pathname: '/fail',
                                        state: {
                                            goTo: '/email',
                                            goToModal: false,
                                            message: 'Error al momento de enviar',
                                            modal: true,
                                            returnTo: '/email'
                                        }
                                    });
                                }

                            case 54:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[8, 15], [25, 32]]);
            }));

            return function () {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.handleClose = function (event, reason) {
            if (reason === 'clickaway') {
                return;
            }
            _this.setState({ open: false });
        };

        _this.handleExited = function () {
            _this.processQueue();
        };

        _this.renderChips = function () {

            var chips = [];
            var name = void 0,
                lastName = void 0;

            if (_this.props.file) {
                chips.push(_react2.default.createElement(
                    'div',
                    { className: _Resumen2.default.imgContainer },
                    _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/file.svg') }),
                    _react2.default.createElement(
                        'span',
                        null,
                        _this.props.draggedFileData.filename
                    )
                ));
            } else {
                _this.state.contactsSelected.map(function (contact) {
                    name = contact.profile.first_name ? contact.profile.first_name.value : '';
                    lastName = contact.profile.last_name ? contact.profile.last_name.value : '';
                    chips.push(_react2.default.createElement(
                        'div',
                        { className: _Resumen2.default.chip },
                        _react2.default.createElement(
                            'div',
                            { className: _Resumen2.default.chipContent },
                            '' + (name + ' ' + lastName)
                        )
                    ));
                });
            }
            return chips;
        };

        var channel = _this.props.data.account.reach.channels.find(function (channel) {
            return channel.type === 'EMAIL';
        });
        _this.state = {
            channel_identifier: channel.identifier,
            template_config_uid: _this.props.data.template_uid,
            account_uid: _this.props.data.account._id,
            subject: _this.props.data.dataToSend.properties ? _this.props.data.dataToSend.properties.subject : _this.props.data.dataToSend.subject,
            contactsSelected: _this.props.data.dataBetweenComponents.contactSelected ? _this.props.data.dataBetweenComponents.contactSelected : null,
            recipients: [],
            sendEmail: _this.props.sendEmail,
            individual: '',
            templateName: _this.props.data.templateName,
            created_on: _this.props.data.created_on,
            userInformation: _this.props.auth,
            messageConfirmSendFile: _this.props.messageConfirmSendFile,
            open: false,
            messageInfo: {},
            created_byUser: null //this.props.draggedFileData.stats.created_byUser,
        };
        return _this;
    }

    (0, _createClass3.default)(Resumen, [{
        key: 'componentWillMount',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var email, channels, emailChannel;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                email = void 0;
                                channels = this.props.account.reach.channels;
                                emailChannel = channels.filter(function (channel) {
                                    return channel.type === 'EMAIL';
                                });

                                if (!(emailChannel.length > 0)) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return this.props.getEmailChannel(emailChannel[0]._id).then(function (data) {
                                    email = data.email.email;
                                });

                            case 6:
                                this.setState({ created_byUser: email });

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentWillMount() {
                return _ref3.apply(this, arguments);
            }

            return componentWillMount;
        }()
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var recipients = [];
            if (this.props.file) {} else {
                this.state.contactsSelected.map(function (contact) {
                    recipients.push(contact.email);
                });
                this.setState({ recipients: recipients });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps) {
                this.setState({
                    template_config_uid: nextProps.data.template_uid,
                    templateName: nextProps.data.templateName
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var total = this.state.contactsSelected ? this.state.contactsSelected.length : this.props.draggedFileData.stats.lines_ok;
            var name = this.props.data.dataToSend.name ? this.props.data.dataToSend.name : this.state.templateName;
            var subject = this.props.data.dataToSend.properties ? this.props.data.dataToSend.properties.subject : this.props.data.dataToSend.subject;

            var sender = this.state.created_byUser;

            var messageInfo = this.state.messageInfo;

            return _react2.default.createElement(
                'div',
                { className: _Resumen2.default.mainResumen },
                _react2.default.createElement(_Snackbar2.default, {
                    key: messageInfo.key,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    open: this.state.open,
                    autoHideDuration: 1000,
                    onClose: this.handleClose,
                    onExited: this.handleExited,
                    ContentProps: {
                        'aria-describedby': 'message-id'
                    },
                    message: _react2.default.createElement(
                        'span',
                        { id: 'message-id' },
                        messageInfo.message
                    ),
                    action: [_react2.default.createElement(
                        _IconButton2.default,
                        {
                            key: 'close',
                            'aria-label': 'Close',
                            color: 'inherit',
                            onClick: this.handleClose
                        },
                        _react2.default.createElement(_Close2.default, null)
                    )]
                }),
                _react2.default.createElement(
                    'div',
                    { className: _Resumen2.default.header },
                    'Resumen del env\xEDo'
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Resumen2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _Resumen2.default.contentContainer },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Enviando a:'
                        ),
                        this.renderChips()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Resumen2.default.dataContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Resumen2.default.titles },
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'Nombre de la plantilla:'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'Asunto del correo:'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'Remitente:'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'Total de correos:'
                                ),
                                ' '
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Resumen2.default.results },
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    name
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    subject
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Resumen2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    sender
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    total
                                ),
                                ' '
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Resumen2.default.footer },
                    _react2.default.createElement(
                        'div',
                        { style: {
                                position: 'relative',
                                fontWeight: 'bold',
                                color: 'rgb(8, 4, 65)',
                                left: '30px',
                                top: '10px'
                            } },
                        'Prueba tu envio'
                    ),
                    _react2.default.createElement('div', null),
                    _react2.default.createElement(
                        'div',
                        { className: _Resumen2.default.testOption },
                        _react2.default.createElement('input', { type: 'text', placeholder: 'correo@prueba.com',
                            onChange: function onChange(change) {
                                return _this3.getTestEmail(change);
                            }, className: _Resumen2.default.prueba }),
                        _react2.default.createElement(
                            'div',
                            { className: _Resumen2.default.testButtonContainer },
                            _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/sendEmailWhite.svg'), onClick: function onClick() {
                                    return _this3.sendEmail('test');
                                } })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: {
                                marginTop: '10px',
                                fontWeight: '700',
                                fontSize: 'larger'
                            } },
                        _react2.default.createElement(_components.Button, { className: _Resumen2.default.buttons, color: 'blue',
                            name: 'Enviar a ' + total + ' correos',
                            onClick: function onClick() {
                                return _this3.sendEmail('send');
                            } })
                    )
                )
            );
        }
    }]);
    return Resumen;
}(_react2.default.Component)) || _class) || _class);
exports.default = Resumen;
module.exports = exports['default'];